import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const TOKEN_STORAGE_KEY = 'auth_token';

const AdminGateway: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = typeof window !== 'undefined' ? window.localStorage.getItem(TOKEN_STORAGE_KEY) : null;
    if (token) navigate('/admin', { replace: true });
    else navigate('/admin/login', { replace: true });
  }, [navigate]);

  return null;
};

export default AdminGateway;
